import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	blogs: [],
};

const blogsSlice = createSlice({
	name: 'blogs',
	initialState: initialState,
	reducers: {
		setBlogs: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setBlogs, reset } = blogsSlice.actions;

export default blogsSlice.reducer;